import React, { useState, useEffect } from "react";
import SideMenu from "../SideMenu/SideMenu";
import Topbar from "../Topbar/v1/Topbar";
import logo from "../../images/MyChurchGPT-LOGO.png";

const MainTemplate = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(true);

  const toggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const adminRoles = ["CHURCH_ADMIN"];
  const user = { name: "John Doe", role: "CHURCH_ADMIN" };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setMenuOpen(false);
      } else {
        setMenuOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call once on mount to set initial state

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    // Implement logout functionality here
    console.log("Logout clicked");
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <div className={`flex flex-col flex-shrink-0 transition-all duration-300 bg-white border-r border-gray-200 ${menuOpen ? "w-64" : "w-16"}`}>
        <SideMenu isOpen={menuOpen} logo={logo} />
      </div>

      {/* Overlay for mobile */}
      <div
        className={`fixed inset-0 bg-gray-600 bg-opacity-75 z-20 transition-opacity duration-300 ${
          menuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        } md:hidden`}
        onClick={closeMenu}
      ></div>
      <div className="flex flex-col flex-1 min-w-0">
        <Topbar
          user={user}
          toggleMenu={toggleMenu}
          onLogout={handleLogout}
          isMenuOpen={menuOpen}
        />

        <main className="flex-1 overflow-auto p-1">
          {/* {adminRoles.includes(user?.role) && (
            <div className="p-4 mb-4 bg-white rounded-md shadow">
              
            </div>
          )} */}

          {children}
        </main>
      </div>
    </div>
  );
};

export default MainTemplate;
